import React from 'react';
import { createRoot } from 'react-dom/client';

import "~/shared/prefilter";
import CounterspeechApp from './containers/CounterspeechApp';

import '~/scss/pages/counterspeech.scss';


createRoot(document.getElementById('counterspeech-app')).render(
    <CounterspeechApp 
        wsRoute = { WEBSOCKETS_ROUTE }
        counterspeechExample = { COUNTERSPEECH_EXAMPLE }
        counterspeechApiEndpoint = { COUNTERSPEECH_API_ENDPOINT }
        availableLlms = { AVAILABLE_LLMS }
    />
);